import { useMemo } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { PromoModelProviderDataModel } from '../models/PromoModelProviderDataModel';

export const useSearchProducts = ({
  itemIds,
  refinedNvalue,
  skipSearchProducts,
  promotion
}) => {
  const store = useStore();
  const { storeId, storeZip, membershipInformation } = store;
  const hasEmptyRequest = !itemIds?.length && !refinedNvalue;
  const skip = skipSearchProducts || hasEmptyRequest;

  const graphQlOptions = useMemo(() => {
    const variables = {
      storeId,
      additionalSearchParams: {
        deliveryZip: storeZip
      },
      loyaltyMembershipInput: membershipInformation?.data?.loyaltyMembership
    };
    if (!refinedNvalue) {
      variables.itemIds = itemIds;
    } else {
      variables.navParam = refinedNvalue;
      variables.pageSize = 6;
      variables.storefilter = 'ALL';
    }
    // passing promoId to searchModel API for temp pricing
    if (promotion?.promotionId) {
      variables.promoId = promotion.promotionId;
    }
    return {
      variables,
      skip,
      dataModel: PromoModelProviderDataModel
    };
  }, [
    itemIds,
    refinedNvalue,
    skip,
    storeId,
    storeZip,
    promotion,
    membershipInformation
  ]);

  const { data, loading, error } = useDataModel('promotionProductsItems', graphQlOptions);

  // we memoize this to prevent new array references triggering consumer rerender
  return useMemo(() => {
    const products = data?.searchModel?.products || [];

    return {
      products,
      loading,
      error,
    };
  }, [data, loading, error]);
};
